// Pure helpers for files on a case — kept out of the JSX so node --test can
// load them. The rendering lives in components/CaseAttachments.jsx.

// The image types the byte sniffer admits (squish-crm-backend
// lib/case-attachments.js ACCEPTED_TYPES). Decided by the stored extension,
// which the server derived from the bytes, never from the uploader's name.
const IMAGE_EXT = new Set(['png', 'jpg', 'jpeg', 'gif', 'webp', 'avif']);

export const isImageFile = (f) => IMAGE_EXT.has(String(f?.extension || f?.name?.split('.').pop() || '').toLowerCase());

export const humanBytes = (n) => (
  !Number.isFinite(n) ? ''
    : n < 1024 ? `${n} B`
    : n < 1024 * 1024 ? `${Math.round(n / 1024)} KB`
    : `${(n / (1024 * 1024)).toFixed(1)} MB`
);

// Which of the case's files does this comment talk about? The customer side
// writes "Attached a file: <name>" when they upload; the CRM composer writes
// "Attached: <name>" into the reply. Both are matched by NAME against the
// case's Files list, so the card under the comment is the real file, not a
// guess from the words. A name that matches no file renders nothing.
const MENTION_RE = /^Attached(?: a file)?: (.+?)\s*$/gm;

export function filesMentioned(body, attachments) {
  if (!body || !attachments?.length) return [];
  const names = [...String(body).matchAll(MENTION_RE)].map(m => m[1].trim().toLowerCase());
  if (!names.length) return [];
  const seen = new Set();
  return attachments.filter(f => {
    const n = String(f.name || '').toLowerCase();
    if (!names.includes(n) || seen.has(f.id)) return false;
    seen.add(f.id);
    return true;
  });
}
